import Vue from 'vue';

import { DocumentPersistence } from '@/types';

/**
 * Shared access to the injected DocumentPersistence strategy. A host screen
 * (e.g. the service questionnaire) provides `documentCtx`; absent a provider the
 * inject default yields `{}`, so the engine falls back to its built-in
 * installation/library behavior. Sealing the Vue 2 inject `this` cast here keeps
 * every consuming renderer free of the `(this as any)` escape hatch.
 */
export default Vue.extend({
  inject: {
    documentCtx: { default: () => ({}) },
  },

  computed: {
    ctx(): DocumentPersistence {
      return (this as any).documentCtx as DocumentPersistence;
    },
  },
});
